
import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { signOut } from "@/lib/auth";
import { toast } from "@/components/ui/use-toast";
import { Button } from "@/components/ui/button";
import { LogOut } from "lucide-react";
import CourseDetailError from "@/components/course-detail/CourseDetailError";
import LearnerCourseContent from "@/components/learner/LearnerCourseContent";
import LearnerCourseLoading from "@/components/learner/LearnerCourseLoading";
import { useLearnerCourse } from "@/hooks/useLearnerCourse";

const LearnerCoursePage = () => {
  const { courseId } = useParams<{ courseId: string }>();
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user && !authLoading) {
      toast({
        title: "Sisselogimine vajalik",
        description: "Palun logi sisse, et pääseda kursusele.",
        variant: "destructive",
      });
      navigate("/");
    }
  }, [user, authLoading, navigate]);

  const { courseData, loading, error, handleCourseCompletion } = useLearnerCourse(courseId);

  const handleLogout = async () => {
    await signOut();
    navigate("/");
  };

  if (authLoading || loading) {
    return <LearnerCourseLoading />;
  }

  if (error || !courseData) {
    return <CourseDetailError />;
  }

  return (
    <div className="min-h-screen bg-kaija-light/60 py-10 fade-in relative">
      <div className="fixed top-4 right-4 z-50">
        <Button variant="ghost" size="sm" onClick={handleLogout}>
          <LogOut className="h-4 w-4 mr-2" />
          Logi valja
        </Button>
      </div>
      <LearnerCourseContent
        courseData={courseData}
        onCourseCompletion={handleCourseCompletion}
      />
    </div>
  );
};

export default LearnerCoursePage;
